const normalizar = (valor) => String(valor || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase();

export const KC_FAO56_POR_CULTURA = {
  soja: {
    label: 'Soja (trópicos)', kcIni: 0.4, kcMid: 1.15, kcEnd: 0.5,
    lIni: 15, lDev: 15, lMid: 40, lLate: 15, altura: 0.75,
  },
  milho: {
    label: 'Milho para grão (colheita seca)', kcIni: 0.3, kcMid: 1.2, kcEnd: 0.35,
    lIni: 20, lDev: 35, lMid: 40, lLate: 30, altura: 2,
  },
  feijao: {
    label: 'Feijão seco', kcIni: 0.4, kcMid: 1.15, kcEnd: 0.35,
    lIni: 20, lDev: 30, lMid: 40, lLate: 20, altura: 0.4,
  },
  cafe: {
    label: 'Café com solo sem cobertura ativa', kcIni: 0.9, kcMid: 0.95, kcEnd: 0.95,
    altura: 2.5,
  },
  'cafe conilon': {
    label: 'Café com solo sem cobertura ativa', kcIni: 0.9, kcMid: 0.95, kcEnd: 0.95,
    altura: 2.5,
  },
  algodao: {
    label: 'Algodão (colheita seca)', kcIni: 0.35, kcMid: 1.2, kcEnd: 0.5,
    lIni: 30, lDev: 50, lMid: 60, lLate: 55, altura: 1.35,
  },
  trigo: {
    label: 'Trigo', kcIni: 0.3, kcMid: 1.15, kcEnd: 0.25,
    lIni: 20, lDev: 25, lMid: 60, lLate: 30, altura: 1,
  },
  arroz: {
    label: 'Arroz inundado', kcIni: 1.05, kcMid: 1.2, kcEnd: 0.9,
    lIni: 30, lDev: 30, lMid: 60, lLate: 30, altura: 1,
  },
  'cana-de-acucar': {
    label: 'Cana-de-açúcar, cana-planta (baixas latitudes)', kcIni: 0.4, kcMid: 1.25, kcEnd: 0.75,
    lIni: 35, lDev: 60, lMid: 190, lLate: 120, altura: 3,
  },
  sorgo: {
    label: 'Sorgo granífero', kcIni: 0.3, kcMid: 1.05, kcEnd: 0.55,
    lIni: 20, lDev: 35, lMid: 40, lLate: 30, altura: 1.5,
  },
  girassol: {
    label: 'Girassol', kcIni: 0.35, kcMid: 1.1, kcEnd: 0.35,
    lIni: 25, lDev: 35, lMid: 45, lLate: 25, altura: 2,
  },
  amendoim: {
    label: 'Amendoim', kcIni: 0.4, kcMid: 1.15, kcEnd: 0.6,
    lIni: 25, lDev: 35, lMid: 45, lLate: 25, altura: 0.4,
  },
  mandioca: {
    label: 'Mandioca, primeiro ano', kcIni: 0.3, kcMid: 0.8, kcEnd: 0.3,
    lIni: 20, lDev: 40, lMid: 90, lLate: 60, altura: 1,
  },
};

export function obterSugestaoKcFao56(cultura) {
  const chave = normalizar(cultura);
  return KC_FAO56_POR_CULTURA[chave] || null;
}

export function listarSugestoesKcFao56() {
  return Object.values(KC_FAO56_POR_CULTURA).filter((sugestao, indice, sugestoes) =>
    sugestoes.findIndex(item => item.label === sugestao.label) === indice
  );
}